module.exports = __webpack_public_path__ + "img/9.HeroHonda2017.c132bcf1.png";